<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Live Coupons <span *ngIf="academyId"> - {{ academyName }}</span> <span
                        class="badge">{{discountCouponData ?
                        discountCouponData.length : 0 }}</span></h4>
            </div>
            <div class="rightDiv">
                <!-- <button class="exportBTn" (click)="exportExcel()"> <span><img
                            src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                    Export</button> -->
                <button class="addBTn" (click)="addNewCoupon()"> <span><img
                            src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Create
                    Coupon</button>
            </div>
        </div>
        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <button (click)="loadDiscountCouponList(lastTableLazyLoadEvent)" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <button (click)="clear()" class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>

                    </li>
                </ul>

            </div>
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table class="expandable" #dt [value]="discountCouponData" [paginator]="true" [rows]="10"
                        [lazy]="true" scrollHeight="auto" scrollDirection="both"
                        (onLazyLoad)="loadDiscountCouponList($event)" [totalRecords]="totalDiscountCouponDataCount"
                        [loading]="loading" [rowsPerPageOptions]="paginationOption"
                        styleClass="p-datatable-gridlines p-datatable-striped w-100">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="name" class="col-180 titleTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Name
                                        <p-sortIcon field="name"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="moduleName" class="col-180 ModuleTD" *ngIf="!academyId">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Module
                                        <p-sortIcon field="moduleName"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="discountTd">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Description
                                    </div>
                                </th>
                                <th pSortableColumn="link" class="CouponUsageTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Coupon Usage
                                        <p-sortIcon field="link"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="link" class="col-180 CouponCodeTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Coupon Code
                                        <p-sortIcon field="link"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="status" class="statusTD">
                                    <div class="col-150 p-d-flex p-jc-between p-ai-center">
                                        Status
                                        <p-sortIcon field="status"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="link" class="col-180 createdDateTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Start Date
                                        <p-sortIcon field="link"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="link" class="col-180 createdDateTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        End Date
                                        <p-sortIcon field="link"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="created_at" class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Date of Creation
                                        <p-sortIcon field="created_at"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="createdBy" class="col-180 CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Created By
                                        <p-sortIcon field="createdBy"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="updated_at" class="col-180 updatedTD"
                                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Last Modified On
                                        <p-sortIcon field="updated_at"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="updatedBy" class="col-180 ModifiedbyTD"
                                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Modified By
                                        <p-sortIcon field="updatedBy"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="col-180 actionTD p-element p-frozen-column">Action</th>
                            </tr>
                            <tr>
                                <th [ngSwitch]="name" class="titleTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'name', 'contains')"
                                        style="width: 100%;"
                                        [value]="dt.filters['name'] ? dt.filters['name'].value : ''" />
                                </th>
                                <th [ngSwitch]="moduleName" class="ModuleTD" *ngIf="!academyId">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'moduleName', 'contains')"
                                        style="width: 100%;"
                                        [value]="dt.filters['moduleName'] ? dt.filters['moduleName'].value : ''" />
                                </th>
                                <th class="discountTd">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'description', 'contains')"
                                        style="width: 100%;"
                                        [value]="dt.filters['description'] ? dt.filters['description'].value : ''" />
                                </th>
                                <th [ngSwitch]="usageData" class="CouponUsageTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'usageData', 'contains')"
                                        style="width: 100%;"
                                        [value]="dt.filters['usageData'] ? dt.filters['usageData'].value : ''" />
                                </th>
                                <th [ngSwitch]="code" class="CouponCodeTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'code', 'contains')"
                                        style="width: 100%;"
                                        [value]="dt.filters['code'] ? dt.filters['code'].value : ''" />
                                </th>
                                <th [ngSwitch]="status" class="statusTD">
                                    <p-dropdown #pDropDownId [options]="statuses" appendTo="body"
                                        (onChange)="dt.filter($event.value, 'status', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>
                                <th [ngSwitch]="startDate" class="createdDateTD">
                                    <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
                                        inputId="calendar" dateFormat="dd-mm-yy"
                                        (onSelect)="setDownloadFlag(); dt.filter($event,'startDate', 'dateIs')"
                                        [showIcon]="true" appendTo="body" showButtonBar="true" monthNavigator="true"
                                        yearNavigator="true" yearRange="2000:2030" showButtonBar="true"
                                        [(ngModel)]="startDateCalValue">
                                    </p-calendar>
                                </th>
                                <th [ngSwitch]="endDate" class="createdDateTD">
                                    <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
                                        inputId="calendar" dateFormat="dd-mm-yy"
                                        (onSelect)="setDownloadFlag(); dt.filter($event,'endDate', 'dateIs')"
                                        [showIcon]="true" appendTo="body" showButtonBar="true" monthNavigator="true"
                                        yearNavigator="true" yearRange="2000:2030" showButtonBar="true"
                                        [(ngModel)]="endDateCalValue">
                                    </p-calendar>
                                </th>
                                <th [ngSwitch]="created_at" class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
                                        inputId="calendar" dateFormat="dd-mm-yy"
                                        (onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
                                        [showIcon]="true" appendTo="body" showButtonBar="true" monthNavigator="true"
                                        yearNavigator="true" yearRange="2000:2030" showButtonBar="true"
                                        [(ngModel)]="createdAtCalValue">
                                    </p-calendar>
                                </th>
                                <th [ngSwitch]="createdBy" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'createdBy', 'contains')"
                                        style="width: 100%;"
                                        [value]="dt.filters['createdBy'] ? dt.filters['createdBy'].value : ''" />
                                </th>
                                <th [ngSwitch]="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
                                        inputId="calendar" dateFormat="dd-mm-yy"
                                        (onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
                                        [showIcon]="true" appendTo="body" showButtonBar="true" monthNavigator="true"
                                        yearNavigator="true" yearRange="2000:2030" showButtonBar="true"
                                        [(ngModel)]="updatedAtCalValue">
                                    </p-calendar>
                                </th>
                                <th [ngSwitch]="updatedBy" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'updatedBy', 'contains')"
                                        style="width: 100%;"
                                        [value]="dt.filters['updatedBy'] ? dt.filters['updatedBy'].value : ''" />
                                </th>

                                <th class="p-element p-frozen-column">
                                    <div class="buttonColumn">
                                        <button class="addBTn" (click)="addColumns()"
                                            [ngClass]="hide ? 'show-column ' : 'hide-column'">
                                            + Add Column
                                        </button>
                                        <button class="removeBTn" (click)="removeColumns()"
                                            [ngClass]="hide ? 'hide-column' : 'show-column '">
                                            - Remove
                                        </button>

                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-discountCouponData let-rowIndex="rowIndex">
                            <tr>
                                <td class="col-180 titleTD">

                                    <span class="textOverFlow1" [pTooltip]="discountCouponData?.name"
                                        severity="secondary" tooltipPosition="bottom">
                                        {{discountCouponData?.name}}
                                    </span>
                                </td>

                                <td class="ModuleTD" *ngIf="!academyId">
                                    <span>{{discountCouponData?.moduleName}}</span>
                                </td>

                                <td class="col-200 discountTd">
                                    <span class="textOverFlow1" pTooltip="{{discountCouponData?.description}}" tooltipPosition="bottom">{{discountCouponData?.description}}</span>
                                </td>

                                <td class="col-200 CouponUsageTD">
                                    <span>{{discountCouponData?.usageData[0]?.name}}</span>
                                </td>

                                <td class="col-200 CouponCodeTD">
                                    <span>{{discountCouponData?.code}}</span>
                                </td>

                                <td class="col-150 statusTD">
                                    	<div class="swichTable">
										<p-inputSwitch [(ngModel)]="discountCouponData.status" (onChange)="changeStatus(discountCouponData)">

										</p-inputSwitch>
										<div class="label activeText" *ngIf="discountCouponData.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!discountCouponData.status">
											Inactive
										</div>
									</div>  
                                </td>

                                <td class="col-200 createdDateTD">
                                    <span>{{discountCouponData?.startDate | date:'dd/MM/yyyy'}}</span>
                                </td>

                                <td class="col-200 createdDateTD">
                                    <span>{{discountCouponData?.endDate | date:'dd/MM/yyyy'}}</span>
                                </td>

                                <td class="col-180 createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    {{discountCouponData.created_at | date: 'dd/MM/yyyy'}}
                                </td>

                                <td class="col-180 CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    {{discountCouponData.created_by}}
                                </td>

                                <td class="col-180 updatedTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    {{discountCouponData.updated_at | date: 'dd/MM/yyyy'}}
                                </td>
                                <td class="col-180 ModifiedbyTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    {{discountCouponData.updated_by}}
                                </td>

                                <!-- <td class="col-180 actionTD"><span class="p-column-title">Action</span>
							<button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-4"
								(click)="onEditArticle(discountCouponData)"></button>
							<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning p-mr-4" (click)="onDelete(discountCouponData)"></button>
						</td> -->
                                <td class="text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right"
                                    style="width: 200px; right: 0px;">
                                    <ul class="actionList">
                                        <li>
                                            <button (click)="onEditCoupon(discountCouponData) " class="editBtn"><img
                                                    src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                        </li>
                                        <li>
                                            <button (click)="onDelete(discountCouponData)" class="deleteBtn"><img
                                                    src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                        </li>
                                    </ul>

                                    <!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2" (click)="viewseller(seller.id)"></button> -->
                                    <!-- <button pButton pRipple icon="pi pi-pencil"
										class="p-button-rounded p-button-success p-mr-2"
										(click)="onEditCoupon(discountCouponData)"></button>
									<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
										(click)="onDelete(discountCouponData)"></button> -->
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">No coupon found.</td>
							</tr>
						</ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>